<template>
  <lk-dropdown
    trigger="custom"
    :visible="visible"
    @on-click="onDropDownclick"
    style="width: 100%">
      <lk-input
        ref="input"
        @on-enter="handleEnter" :placeholder="placeholder" @on-change="onInputChange" @on-blur="onInputBlur" :value="value" :maxlength='maxlength' @on-focus="onInputFocus">
        <template slot="prepend">
          <slot name="prepend"></slot>
        </template>
      </lk-input>
      <lk-dropdown-menu slot="list" :style="{ maxHeight: `${maxHeight}px`, overflow:'auto'}">
        <lk-dropdown-item v-for="(item, index) in dropdownList" :key="index" :name='item.value'>
          {{item.name}}
        </lk-dropdown-item>
      </lk-dropdown-menu>
  </lk-dropdown>
</template>
<script>
export default {
  name: 'DropdownInput',
  data() {
    return {
      visible: false,
    };
  },
  props: {
    dropdownList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: [String, Number],
      default: '',
    },
    maxlength: {
      type: Number,
    },
    maxHeight: {
      type: Number,
      default: 120,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    blur() {
      this.$refs.input.blur();
    },
    handleEnter(event) {
      this.$emit('on-enter', event);
    },
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        // eslint-disable-next-line prefer-spread
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    onInputChange(e) {
      const val = e.target.value;
      this.$emit('on-search', val);
      this.$emit('input', val);
    },
    onInputBlur() {
      this.visible = false;
      this.dispatch('FormItem', 'on-form-blur', this.value);
    },
    onDropDownclick(val) {
      this.$emit('input', val);
    },
    onInputFocus() {
      this.$emit('on-focus', this.value);
    },
  },
  watch: {
    dropdownList(val) {
      if (val.length > 0) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
  },
};
</script>
